// src/screens/AuthScreen.js
import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Login from "../components/Login";
import SignUp from "../components/SignUp";
import logo from "../assets/logo512.png";
import background from "../assets/InfiNFT_bkg.png";
import back from "../assets/1.png";
import front from "../assets/2.png";
import text from "../assets/royale_logo_wide_text.png";
import { auth, db } from "../config/firebaseConfig";
import { MainContext } from "../App";
import { red } from "@mui/material/colors";

const HomeScreen = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Grid
      item
      container
      xs={12}
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Grid
        item
        container
        xs={12}
        md={8}
        sx={{
          display: { xs: "none", md: "flex" },
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {[back, back, back, back, front].map((card, i, arr) => {
          const total = arr.length;
          const middleIndex = Math.floor(total / 2);
          const offset = (i - middleIndex) * 50; // space between cards
          const rotation = (i - middleIndex) * 10; // rotate left/right from center

          return (
            <motion.img
              key={i}
              src={card}
              alt=""
              initial={{ x: 0, y: 0, rotate: 0, opacity: 0 }}
              animate={{
                x: offset,
                y: -Math.abs(i - middleIndex) * -20, // subtle vertical offset for depth
                rotate: rotation,
                opacity: 1,
              }}
              transition={{
                delay: i * 0.2,
                type: "spring",
                stiffness: 100,
                damping: 10,
              }}
              style={{
                width: "20%",
                position: "absolute",
                marginBottom: "20%",
                zIndex: i, // ensure order
              }}
            />
          );
        })}
        <motion.img
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, delay: 1 }}
          src={text}
          alt=""
          style={{ width: "80%", zIndex: 6, marginTop: "20%" }}
        />
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, delay: 1 }}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: -40,
          }}
        >
          <Typography
            variant="h4"
            style={{ color: "white", fontWeight: "bold", margin: 0 }}
          >
            The Ultimate NFT Showdown.
          </Typography>
          <Typography
            variant="h5"
            style={{ color: "white", fontWeight: "bold", margin: 0 }}
          >
            Battle, Collect, Earn, and Dominate!
          </Typography>
        </motion.div>
      </Grid>

      <Grid
        item
        container
        xs={12}
        md={4}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            width: "100%",
            position: "absolute",
            top: "5%",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[back, back, back, back, front].map((card, i, arr) => {
              const total = arr.length;
              const middleIndex = Math.floor(total / 2);
              const offset = (i - middleIndex) * 35; // space between cards
              const rotation = (i - middleIndex) * 10; // rotate left/right from center

              return (
                <motion.img
                  key={i}
                  src={card}
                  alt=""
                  initial={{ x: 0, y: 0, rotate: 0, opacity: 0 }}
                  animate={{
                    x: offset,
                    y: -Math.abs(i - middleIndex) * -10, // subtle vertical offset for depth
                    rotate: rotation,
                    opacity: 1,
                  }}
                  transition={{
                    delay: i * 0.2,
                    type: "spring",
                    stiffness: 100,
                    damping: 10,
                  }}
                  style={{
                    width: "20%",
                    position: "absolute",
                    marginBottom: "20%",
                    zIndex: i, // ensure order
                  }}
                />
              );
            })}
            <motion.img
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.5, delay: 1 }}
              src={text}
              alt=""
              style={{
                width: "60%",
                zIndex: 6,
                marginTop: "8%",
              }}
            />
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.5, delay: 1 }}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 6,
              }}
            >
              <Typography
                variant="h5"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  margin: 0,
                  textShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                }}
              >
                The Ultimate NFT Showdown.
              </Typography>
              <Typography
                variant="caption"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  margin: 0,
                  textShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                }}
              >
                Battle, Collect, Earn, and Dominate!
              </Typography>
            </motion.div>
          </div>
        </Box>

        <Box
          sx={{
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "white",
            marginTop: { xs: "30%", md: 0 },
          }}
        >
          <Box
            sx={{
              width: { xs: "100px", md: "200px" },
              marginBottom: { xs: 0, md: "40px" },
            }}
          >
            <motion.img
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1.5 }}
              src={logo}
              alt=""
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          </Box>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.05 }}
          >
            {/* <Tabs value={activeTab} onChange={handleTabChange} centered>
					<Tab label="Login" />
					<Tab label="Sign Up" />
				</Tabs> */}
            {activeTab === 0 && <Login />}
            {activeTab === 1 && <SignUp />}
          </motion.div>
        </Box>
      </Grid>
    </Grid>
  );
};

export default HomeScreen;
